export default function () {
  const DISPLAY_KEY_PREFIX = 'entity.appointment.statuses.';

  const NO_SHOW = 'NO_SHOW';
  const HONORED = 'HONORED';
  const CANCELED = 'CANCELED';

  const displayStatuses = [NO_SHOW, HONORED, CANCELED]


  function getDisplayKeyByStatus(status) {
    return DISPLAY_KEY_PREFIX + status.toLowerCase();
  }

  return {
    NO_SHOW,
    HONORED,
    CANCELED,
    displayStatuses,
    getDisplayKeyByStatus
  }
}
